import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { EXTRA_INFO_MORE_BUSINESS_DETAILS_ROUTE } from '~/constants/routes';
import { useAppContent, useExtraInfo } from '~/hooks';
import { Cover } from '~/types/cover';
import { AppRoute, ReviewItem } from '~/types/types';
import { coverToPosition, getInterestedPartiesByCover } from '~/utils';

interface ReviewExcessProps {}

const ReviewInterestedParties: React.FC<ReviewExcessProps> = () => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.review.fields.interestedThirdParties',
  });

  const { interestedParties } = useExtraInfo();

  const interestedPartiesByCover = Object.entries(getInterestedPartiesByCover(interestedParties!))
    .map((coverAndParty) => ({
      coverAndParty,
      position: coverToPosition[coverAndParty[0] as Cover],
    }))
    .sort((a, b) => a.position - b.position)
    .map(({ coverAndParty }) => coverAndParty)
    .map(([category, parties]) => [
      { category },
      parties.map((name) => ({ label: ' ', data: String(name) })),
    ])
    .flat(2);

  const interesetdPartiesReviewList: ReviewItem[] = [
    ...(interestedParties!.length > 0
      ? interestedPartiesByCover
      : [{ label: getTextContent('none'), data: '' }]),
  ];

  return (
    <ReviewList
      list={
        interesetdPartiesReviewList.reduce((prev, curr, idx) => {
          let list;
          if ('category' in curr && curr.category) {
            list = {
              id: idx,
              name: curr.category,
              label: curr.category,
              value: curr.category,
            };
          } else if ('label' in curr) {
            list = {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            };
          }
          return {
            ...prev,
            [String(idx)]: list,
          };
        }, {}) as ListType
      }
      title={getTextContent('title')}
      editRoute={`${EXTRA_INFO_MORE_BUSINESS_DETAILS_ROUTE}#interested-third-parties` as AppRoute}
    />
  );
};

export default ReviewInterestedParties;
